import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { UpdateCaseStatusCommand } from './update-case-status.command';

/**
 * Update case status use case.
 * Updates the status of a case.
 */
@Injectable({ providedIn: 'root' })
export class UpdateCaseStatusUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  /**
   * Executes the update case status use case.
   * @param command - The command containing case ID and status ID
   * @returns Observable void
   */
  public execute(command: UpdateCaseStatusCommand): Observable<void> {
    this._state.setSavingCases(true);
    this._state.setErrorCases(null);

    return this._repository.updateCaseStatus(command.caseId, command.statusId).pipe(
      tap(() => {
        this._state.setSavingCases(false);
      }),
      catchError((error) => {
        this._state.setErrorCases(error.message || 'Failed to update case status');
        this._state.setSavingCases(false);
        return throwError(() => error);
      })
    );
  }
}
